import React from 'react';
import {Box, HStack, View, VStack, Text} from 'native-base';
import {
  ColorType,
  ResponsiveValue,
} from 'native-base/lib/typescript/components/types';
import {ILinearGradientProps} from 'native-base/lib/typescript/components/primitives/Box/types';

interface IProps {
  label: string;
  labelColor: string;
  value: string;
  valueColor: string;
  backgroundColor?: ResponsiveValue<ColorType | ILinearGradientProps>;
  multiline?: boolean;
}

interface ISectionItemValue {
  multiline: boolean | undefined;
  color?: ColorType;
  value: string;
}

const SectionItemValue = ({multiline, color, value}: ISectionItemValue) => {
  if (multiline) {
    return (
      <VStack paddingLeft="2" flexBasis={'auto'}>
        <Text
          color={color}
          fontSize="16"
          textTransform={'capitalize'}
          textAlign="right">
          {value}
        </Text>
      </VStack>
    );
  }
  return (
    <View height="6" paddingLeft="2">
      <Text color={color} fontSize="16" textTransform={'capitalize'}>
        {value}
      </Text>
    </View>
  );
};

const SectionItem = ({
  label,
  value,
  labelColor,
  valueColor,
  backgroundColor,
  multiline,
}: IProps) => {
  return (
    <HStack
      space={5}
      marginBottom={0}
      backgroundColor={backgroundColor ?? '#FFFFFF'}
      paddingY={3}
      paddingX={5}>
      <VStack space="0" flex={1}>
        <Box justifyContent="center">
          <Text
            color={labelColor}
            fontSize={'16'}
            numberOfLines={3}
            fontWeight="semibold">
            {label}
          </Text>
        </Box>
      </VStack>
      <HStack w="200" justifyContent="flex-end" alignItems={'center'}>
        <SectionItemValue
          multiline={multiline}
          color={valueColor}
          value={value}
        />
      </HStack>
    </HStack>
  );
};

export default SectionItem;
